import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { TextField } from "@mui/material";
import React from "react";

const january1st2018 = new Date("2018-01-01T00:00:00Z");

let maxDateEnd = new Date();
maxDateEnd.setDate(maxDateEnd.getDate() + 1);

export const StartDatePicker = (props) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DesktopDatePicker
				label="Start Date"
				inputFormat="dd/MM/yyyy"
				value={props.date}
				minDate={january1st2018}
				shouldDisableDate={(date) => date < january1st2018}
				disableFuture
				maxDate={new Date()}
				onChange={(newValue) => {
					props.onChange(newValue);
				}}
				renderInput={(params) => <TextField label="Start date" size="small" sx={{ maxWidth: 170, marginRight: "1rem", marginBottom: "1rem", ...props.sx }} {...params} />}
			/>
		</LocalizationProvider>
	);
};

export const EndDatePicker = (props) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DesktopDatePicker
				label="End Date"
				inputFormat="dd/MM/yyyy"
				value={props.date}
				minDate={january1st2018}
				shouldDisableDate={(date) => date < january1st2018}
				maxDate={maxDateEnd}
				onChange={(newValue) => {
					props.onChange(newValue);
				}}
				renderInput={(params) => <TextField label="End date" size="small" sx={{ maxWidth: 170, ...props.sx }} {...params} />}
			/>
		</LocalizationProvider>
	);
};
